export  default [

    {
        path: "/inspect",
        name: "inspect",
        component: () => import("./index"),
        meta: {
            permiss:['INSPECT_TASK_SHOW'],
            title: "巡检任务"
        }
    },
    {
        path: "/inspect/device/:state/:id",
        name: "inspectDevice",
        component: () => import("./tab/InspectDeviceList"),
        meta: {
            permiss:['INSPECT_TASK_SHOW'],
            title: "巡检设备"
        }
    },
    {
        path: "/inspect/detail/:id",
        name: "inspectDetail",
        component: () => import("./components/InspectDeviceDetail"),
        meta: {
            title: "巡检设备详情"
        }
    },
    {
        path: "/inspect/deal/:id",
        name: "inspectDeal",
        component: () => import("./components/InspectDeviceDeal"),
        meta: {
            title: "提交巡检设备"
        }
    },
]
